export const REGION = 'us-east-1';
export const USER_POOL_ID = 'us-east-1_hv0hffukL';
export const APP_CLIENT_ID = '5iu1uquajj4pdo5v48dq2t4e1o';
export const IDENTITY_POOL_ID = 'us-east-1:a7c9ac55-5c3e-4927-9555-748fa95a3d78';
export const COGNITO_DOMAIN = 'ee-portal-auth-prod.auth.us-east-1.amazoncognito.com';
export const IS_LOCAL_DEV = 'false';
export const STAGE = 'prod';
export const APPEAL_ENABLED = 'false';